import { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/toaster";
import { initLenis, scrollTop } from "@/lib/scroll";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="grid min-h-screen place-items-center bg-white px-6 text-center">
                    <div>
                        <p className="font-display text-2xl font-extrabold text-ink">
                            Ups, terjadi kesalahan
                        </p>
                        <p className="mt-2 text-sm text-ink/50">
                            Muat ulang halaman untuk mencoba lagi.
                        </p>
                        <button
                            onClick={() => window.location.reload()}
                            data-testid="error-boundary-reload"
                            className="mt-6 rounded-full bg-brand px-8 py-3 font-bold text-white"
                        >
                            Muat Ulang
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        scrollTop();
    }, [pathname]);
    return null;
}

function App() {
    useEffect(() => {
        const destroy = initLenis();
        return destroy;
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
                <Toaster />
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
